import React, { useEffect, useState } from "react"
import utill from "lib/utill"
import { useLocation, useNavigate } from "react-router-dom"
import { Box, createTheme, ThemeProvider } from "@mui/material"
import Header from "components/Header"
import { themeSettings } from "theme"
import introVideo from '../../assets/intro.mov'; // 비디오 파일 경로

const Dashboard = () => {
  const navigate = useNavigate()
  const theme = createTheme(themeSettings("light", "default"))

  const [adminoid, setAdminOid] = useState("")
  const [id, setId] = useState("")
  const [adminlevel, setAdminLevel] = useState("")
  const [hostTitle, setHostTitle] = useState("")
  const [isDataReady, setIsDataReady] = useState(false);

  useEffect(() => {
    const adminOidValue = sessionStorage.getItem("x-a-d-a");
    const idValue = sessionStorage.getItem("x-a-d-i");
    const adminLevelValue = sessionStorage.getItem("x-a-d-l");
    const hostTitleValue = sessionStorage.getItem("x-a-h-t");
  
    if (adminOidValue && idValue && adminLevelValue && hostTitleValue) {
      const iadminoid = utill.base64Decode(adminOidValue);
      const iid = utill.base64Decode(idValue);
      const ilevel = utill.base64Decode(adminLevelValue);
      setAdminOid(iadminoid);
      setId(iid);
      setAdminLevel(ilevel);
      setHostTitle(utill.base64Decode(hostTitleValue));
      setIsDataReady(true); // 데이터가 준비되었음을 표시
    } else {
      navigate("/login");
    }
  }, [navigate]);
  
  if (!isDataReady) {
    return (    
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          position: 'relative',
          height: '100vh', // 화면 높이에 맞추기
          overflow: 'hidden', // 넘치는 부분 숨기기
        }}
      >
      </Box>
    </ThemeProvider>)// 데이터가 준비될 때까지 로딩 표시
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          position: 'relative',
          height: '100vh', // 화면 높이에 맞추기
          overflow: 'hidden', // 넘치는 부분 숨기기
        }}
      >
        <video
          src={introVideo}
          autoPlay
          loop
          muted
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            minWidth: '100%',
            minHeight: '100%',
            width: 'auto',
            height: 'auto',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </Box>
    </ThemeProvider>
  )
}

export default Dashboard
